// @ts-strict-ignore
import React from 'react'
import { View } from 'react-native'
import { useSelector } from 'APP/Hooks/redux'

import InactiveInfoCard from 'APP/Components/InfoCard/InactiveInfoCard'
import ZeroEligibilityInfoCard from 'APP/Components/InfoCard/ZeroEligibilityInfoCard'
import styled from 'styled-components/native'

const InactiveContainer = styled(View)`
  margin-top: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  margin-bottom: ${({ theme }) => theme.metrics.baseMargin * 2}px;
`

const InactiveChatInfoCard = () => {
  const { eligibleServices, eligibilityIntervals } = useSelector((state) => state.patient.profile)
  const isEligible = eligibleServices && Object.keys(eligibleServices).length > 0
  const hasEligibilityIntervals = eligibilityIntervals?.length > 0

  if (isEligible) return null

  if (hasEligibilityIntervals) {
    return (
      <InactiveContainer testID={'INACTIVE_INFO_CARD_VIEW'}>
        <InactiveInfoCard testId="inactiveCard" />
      </InactiveContainer>
    )
  } else {
    return (
      <InactiveContainer testID={'ZERO_ELIGIBILITY_INFO_CARD_VIEW'}>
        <ZeroEligibilityInfoCard testId="zeroEligibilityCard" />
      </InactiveContainer>
    )
  }
}

export default InactiveChatInfoCard
